"use client";

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useSipContext } from "@/context/SipContext";

import {
  LayoutDashboard,
  Car,
  Smartphone,
  User,
  ListIcon,
  Calendar,
  Phone,
} from "lucide-react";
import { useTranslate } from "react-admin";
import { useLocation, NavLink } from "react-router-dom";

export function TaxiDispatchOperator() {
  const {hasFreePBX} = useSipContext()
  const location = useLocation();

  const translate = useTranslate();

  const data = {
    dispatch: {
      title: "Dispatch",
      navs: [
        {
          name: "Dispatch",
          url: "/",
          icon: LayoutDashboard,
        },
        {
          name: translate(`orders.name`, { smart_count: 2 }),
          url: "/taxi-orders",
          icon: ListIcon,
        },
        (hasFreePBX ? {
          name: "Call reports",
          url: "/call-logs",
          icon: Phone
        } : false),
        {
          name: translate(`reservations.name`, { smart_count: 2 }),
          url: "/reservations",
          icon: Calendar,
        },
        {
          name: translate(`devices.name`, { smart_count: 2 }),
          url: "/devices",
          icon: Smartphone,
        },
        {
          name: translate(`drivers.name`, { smart_count: 2 }),
          url: "/drivers",
          icon: User,
        },
        {
          name: translate(`vehicles.name`, { smart_count: 2 }),
          url: "/vehicles",
          icon: Car,
        },
        {
          name: translate(`clients.name`, { smart_count: 2 }),
          url: "/clients",
          icon: User,
        },
      ].filter(Boolean),
    },
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel>{data.dispatch.title}</SidebarGroupLabel>
      <SidebarMenu>
        {data.dispatch.navs.map((item) => (
          <SidebarMenuItem
            key={item.name}
            className={`${item.url == location.pathname ? "bg-gray-200 dark:bg-neutral-600 rounded-lg" : ""}`}
          >
            <SidebarMenuButton className="text-[15px] font-medium" asChild>
              <NavLink to={item.url}>
                <item.icon />
                <span>{item.name}</span>
              </NavLink>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
